import React, { useRef, useState } from 'react';
import './information.styles.scss';

import TextEditor from '@/components/SHARED/text-editor/text-editor.component';
import { sanitize } from '@/utils/sanitize';
import TextAreaWordCount from '@/components/SHARED/text-area-word-count/text-area-word-count.component';
import { useSelector } from 'react-redux';
import ImportModal from './import-modal.component';
import { ModalConfirm } from '@/components/modal/modal.component';
import ModalMyContent from '@/components/SHARED/content-manager/modal-my-content.component';
import useAnalytics from '@/utils/useAnalytics';

const ManageContentInformation = ({
  type,
  saveData,
  formData,
  existingDescription,
  clearEditor,
  setClearEditor,
  textEditorLabel
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [showImportModal, setShowImportModal] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const { trackEvent, trackException } = useAnalytics();
  const approveRef = useRef();

  function launchMyContentImport() {
    setConfirmMessage('Are you sure you want to import content from your content library? ' +
      'This will overwrite any existing information you have entered for this element.');
    approveRef.current = () => {
      setShowImportModal(true);
    }
  }

  function importElement(element) {
    console.log(element);
    const keys = [
      'name',
      'desc',
      'icon'
    ]
    Object.keys(element).forEach(key => {
      if (key.includes('opt_')) {
        keys.push(key);
      }
    })
    keys.forEach(key => {
      if (element[key]) {
        saveData(key, element[key]);
      }
    })
    trackEvent(
      'import_element',

    );
    setShowImportModal(false);
  }

  return (
    <div className={`information-form ${screenSize}`}>
      <div className={`g-list-item form-section ${screenSize}`}>
        {/* g-list-item form-section */}
        <div className='information-form-head'>
          <h3>Information</h3>
          <button
            className='g-button small-btn'
            onClick={() => launchMyContentImport()}>
            {
              screenSize === 'mobile' ? 'Import' : 'Import from My Conent'
            }
          </button>
        </div>
        <hr />
        <div className='field small'>
          <label>{type === 'secretCode' ? 'Secret Code Word(s)' : 'Name'}<span className='required'>*</span></label>
          <input
            type='text'
            id='name'
            value={
              formData && formData.name ?
                formData.name :
                ''
            }
            onChange={(e) => saveData('name', sanitize(e.target.value))}
          />
        </div>
        <div className="g-space-1"></div>
        <div className='field small'>
          <label>{textEditorLabel}</label>
          {
            (type === "challenge")
              ?
              <TextEditor
                setTextContent={(e) => saveData('desc', e)}
                textContent={formData && formData.desc}
                existingContent={existingDescription}
                clearEditor={clearEditor}
                setClearEditor={setClearEditor}
              />
              :
              <TextAreaWordCount
                saveData={saveData}
                count={50}
                keyId="desc"
                existingText={formData.desc ?? ""}
              />
          }
        </div>
        <div className="g-space-1"></div>
      </div>
      {/* <ImportModal
				show={showImportModal}
				cancel={() => setShowImportModal(false)}
				saveData={saveData} /> */}
      <ModalMyContent
        show={showImportModal}
        cancel={() => setShowImportModal(false)}
        chooseElement={importElement}
        type={type} />
      <ModalConfirm
        show={!!confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
    </div>
  )
}

export default ManageContentInformation;